import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { VscFilePdf } from "react-icons/vsc";

const links = [
  { id: 1, icon: <FaLinkedin size={18} />, href: "https://www.linkedin.com/in/khubayb-kapila-8ab85a156/", label: "LinkedIn" },
  { id: 2, icon: <FaGithub size={18} />, href: "https://github.com/khubaybk", label: "GitHub" },
  { id: 3, icon: <HiOutlineMail size={20} />, href: "mailto:kkhubayb@gmail.com", label: "Email" },
  { id: 4, icon: <VscFilePdf size={18} />, href: "KhubaybKapilaCV.pdf", label: "Resume", download: true },
];

const SocialLinks = () => {
  return (
    <div className="fixed bottom-10 left-4 z-40 hidden flex-col items-center gap-4 xl:flex">
      <ul className="flex flex-col items-center gap-1.5">
        {links.map(({ id, icon, href, label, download }) => (
          <li key={id} className="group relative">
            <a
              href={href}
              download={download}
              target={download ? undefined : "_blank"}
              rel="noreferrer"
              aria-label={label}
              className="flex h-9 w-9 items-center justify-center rounded-md border border-editor-border bg-editor-panel text-syntax-comment transition-all duration-200 hover:-translate-y-0.5 hover:border-syntax-fn/50 hover:text-syntax-fn"
            >
              {icon}
            </a>
            <span className="pointer-events-none absolute left-11 top-1/2 -translate-y-1/2 whitespace-nowrap rounded border border-editor-border bg-editor-elevated px-2 py-1 text-[0.68rem] text-zinc-300 opacity-0 transition-opacity group-hover:opacity-100">
              {label}
            </span>
          </li>
        ))}
      </ul>
      <span className="h-16 w-px bg-gradient-to-b from-editor-border to-transparent" />
    </div>
  );
};

export default SocialLinks;
